import React, { useState } from "react";
import Header from "../components/Header";
import SearchForm from "../components/SearchForm";
import Benefits from "../components/Benefits";
import PopularDestinations from "../components/PopularDestinations";

function HomePage() {
  const [selectedDestination, setSelectedDestination] = useState("");

  const handleDestinationSelect = (country) => {
    setSelectedDestination(country);
  };

  return (
    <div>
      <div
        className="min-h-screen bg-cover bg-center relative"
        style={{ backgroundImage: "url('/background2.jpeg')" }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
        <div className="relative">
          <Header isTransparent={true} />
          <div className="pt-12 md:pt-20 px-4">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-2 md:mb-4 text-center text-white">
              Search & Book Flights
            </h1>
            <p className="text-lg md:text-2xl font-bold text-center text-white mb-8">
              Explore the best deals online today
            </p>
          </div>
          <SearchForm selectedDestination={selectedDestination} />
        </div>
      </div>
      <Benefits />
      <PopularDestinations onDestinationSelect={handleDestinationSelect} />
    </div>
  );
}

export default HomePage;
